import {useMemo} from 'react'
import {GetFormattedBulkPointModifiers} from '@/models/BulkModifierModel'
import {useDataTable} from '@/hooks/useDataTable-hook'
import { getBulkModifierCsvFile, getBulkModifiers } from '@/services/bulkModifiers'
import {BulkModifiersListColConfig} from '@/services/MockData/BulkModifiersList/BulkModifiersListColConfig'
import {useQueries} from '@tanstack/react-query'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'

export const useBulkModifiers = () => {
  const { setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr, handleResetAll } = useDataTable()

  // Move search params to request body and only use query params for pagination/sorting
  const queryParams = useMemo(() => {
    const params = new URLSearchParams()

    // Add sorting parameters if available
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj.column)
      params.append('order', sortingObj.direction)
    }

    // Add pagination parameters
    params.append('pageSize', 10)
    params.append('page', pageIndex || 0)

    //this code can be used to filter the data based on the searchArr

    // // Add search parameters if available
    // if (searchArr.length > 0) {
    //   searchArr.forEach(searchObj => {
    //     if (searchObj.type === 'date') {
    //       // params.append(searchObj.field, getFormattedDateString(searchObj.value))
    //     } else {
    //       // params.append(searchObj.field, searchObj.value)
    //     }
    //   })
    // }

    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])

  const [{ data, isLoading, isFetching }] = useQueries({
    queries: [
      {
        queryKey: ['BULK_MODIFIERS', queryParams, searchArr],
        queryFn: () => getBulkModifiers(queryParams, searchArr),
      },
    ],
  })

  const resultsData = useMemo(() => data || {}, [data])
  const bulkModifiersData = useMemo(() => GetFormattedBulkPointModifiers(resultsData), [resultsData])

  const onDownloadBtnClick = async selectedIds => {
    const requestBody = {
      ids: selectedIds,
      filters: searchArr,
    }

    try {
      const data = await getBulkModifierCsvFile(queryParams,requestBody);
      const fileName = `BulkModifier_${getDateWithTimeString()}`;
      downloadCSVFiles(data, fileName);
    } catch (error) {
      console.error("Error downloading CSV file:", error);
    }
  }

  return {
    bulkModifiersData,
    bulkModifiersColConfigData: BulkModifiersListColConfig,
    isLoading: isLoading,
    isFetching: isFetching,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    pageIndex,
    sortingObj,
    searchArr,
    handleResetAll,
    onDownloadBtnClick
  }
}
